var exports = {
  "content": "xf0b3b88a--57e6f9--content",
  "media": "xf0b3b88a--57e6f9--media",
  "author-info": "xf0b3b88a--57e6f9--author-info",
  "phone": "xf0b3b88a--57e6f9--phone",
  "chats-block": "xf0b3b88a--57e6f9--chats-block",
  "user-info": "xf0b3b88a--57e6f9--user-info",
  "header": "xf0b3b88a--57e6f9--header",
  "header-title": "xf0b3b88a--57e6f9--header-title",
  "address": "xf0b3b88a--57e6f9--address",
  "description": "xf0b3b88a--57e6f9--description",
  "offer-menu": "xf0b3b88a--57e6f9--offer-menu",
  "footer": "xf0b3b88a--57e6f9--footer",
  "recidivist": "xf0b3b88a--57e6f9--recidivist",
  "mortgage-banner": "xf0b3b88a--57e6f9--mortgage-banner",
  "vas-list": "xf0b3b88a--57e6f9--vas-list",
};

module.exports = exports;
